module.exports = __webpack_public_path__ + "img/esg.57092ee1.svg";